<template>
  <div style="display: inline-block">
    <el-button :size="size" type="primary" @click="updateFileList(fileText)">
      {{ btnName ? btnName : getFileList(fileText) }}
    </el-button>

    <el-dialog
      v-draggable
      :visible.sync="dialogState.show1"
      append-to-body
      :close-on-click-modal="false"
      class="dialog"
      :title="dialogTitle"
      width="50%"
      @close="dialogClose"
    >
      <myUploadTable
        v-if="dialogState.show1"
        :homeOnlyKey="homeOnlyKey"
        :list="tableList"
        :type="type"
        :status="status"
        :showLeft="showLeft"
        @uploadSuccess="uploadSuccess"
        @uploadDelete="uploadDelete"
      >
        <template #leftContent>
          <slot name="leftContent"></slot>
        </template>
      </myUploadTable>
    </el-dialog>
  </div>
</template>

<script>
function isNumericValue(value) {
  if (typeof value === 'number') return Number.isFinite(value)
  if (typeof value !== 'string') return false
  const text = value.trim()
  if (!text) return false
  return !Number.isNaN(Number(text))
}

export default {
  name: 'myFileCount',
  props: {
    btnName: {
      type: String,
      default: null,
    },
    homeOnlyKey: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
    fileText: {
      type: String,
      default: null,
    },
    dialogTitle: {
      type: String,
      default: '文件处理',
    },
    status: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 2,
    },
    valueName: {
      type: String,
      default: null,
    },
    showLeft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableList: [],
      dialogState: {
        show1: false,
      },
    }
  },
  watch: {
    fileText: {
      handler(newVal) {
        try {
          const parsed = JSON.parse(newVal)
          this.tableList = isNumericValue(parsed) ? [] : parsed
        } catch (error) {
          this.tableList = []
        }
      },
      immediate: true,
    },
  },
  methods: {
    getFileList(list) {
      let count = 0
      try {
        const parsed = JSON.parse(list)
        count = isNumericValue(parsed) ? 0 : parsed.length
      } catch (error) {
        count = 0
      }
      return count
    },
    updateFileList(list) {
      this.$emit('updateFileList', this.valueName)
      try {
        const parsed = JSON.parse(list)
        this.tableList = isNumericValue(parsed) ? [] : parsed
      } catch (error) {
        this.tableList = []
      }
      this.dialogState.show1 = true
    },
    uploadSuccess(list) {
      const fileText = JSON.stringify(list || [])
      this.tableList = list || []
      this.$emit('uploadSuccess', fileText, this.valueName)
    },
    uploadDelete(list) {
      const fileText = JSON.stringify(list || [])
      this.tableList = list || []
      this.$emit('uploadSuccess', fileText, this.valueName)
    },
    dialogClose() {
      this.dialogState.show1 = false
      this.$emit('dialogClose', this.valueName)
    },
  },
}
</script>
